<template>
  <div class="detail-wrap">
    <el-form ref="formData" :rules="rules" :model="formData" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}数据字典
        </div>
        <div class="fr">
          <el-button v-if="(sys_dict_add && formData.id == null) || (sys_dict_edit && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <div class="title first"><b>基础信息</b></div>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  类型
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text" autocomplete="off" v-model="formData.dictType" clearable
                              @blur="inspection"/>
                  </div>
                </td>
                <th>
                  <em class="f-red">*</em>
                  编码
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text"  autocomplete="off" v-model="formData.description" clearable
                              @blur="inspection"/>
                  </div>
                </td>
                <th>
                  <em class="f-red">*</em>
                  字典类型
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-select v-model="formData.systemFlag" clearable style="width: 9vw !important; ;">
                      <el-option v-for="item in dictTypes" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </td>

                <th>
                  备注信息
                </th>
                <td class="table-row">
                  <div class="table-cell">
                    <el-input type="text"  autocomplete="off" v-model="formData.remarks" clearable
                              @blur="inspection"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item">
            <div class="title first">
              <div class="title first"><b>字典项</b> <el-button v-if="sys_dict_add || sys_dict_edit" type="primary" class="button-sty btn_zdy" @click="AddListRow()">
                <i class="el-icon-plus"></i>
                新增</el-button></div>

            </div>
            <el-table ref="filterTable" border :data="formData.dictItemDto" class="table_item pic_item"
                      style="margin: 0px 10px; width: 98%;"
                      :header-cell-style="{ background: '#F6FAFF',padding: '0',   fontSize:'12px',color:'#808080'}"
                      row-key="id"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :header-row-style="{height:'36px'}" :row-style="{height:'45px',fontSize:'12px', background: '#fff'}">
              <el-table-column type="selection" width="55">
              </el-table-column>

              <el-table-column prop="label" label="标签名" width="150">
                <template slot-scope="scope">
                  <el-input v-model="formData.dictItemDto[scope.$index].label" placeholder="请输入">
                  </el-input>
                </template>
              </el-table-column>
<!--              <el-table-column prop="value" label="数值" width="120">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-input v-model="formData.dictItemDto[scope.$index].itemValue" placeholder="请输入" readonly>-->
<!--                  </el-input>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column prop="description" label="编码" width="180">
              <template slot-scope="scope">
                <el-input v-model="formData.dictItemDto[scope.$index].description" placeholder="请输入">
                </el-input>
              </template>
            </el-table-column>
              <el-table-column prop="refDictId" label="关联字典" width="150">
                <template slot-scope="scope">
                    <el-input type="text" autocomplete="off" v-model="formData.dictItemDto[scope.$index].refDictName" clearable  @clear="lin('','')" >
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="doShowDictDialog(scope.$index)"></i>
                    </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="refDictItemId" label="关联字典值" width="150">
                <template slot-scope="scope">
                    <el-input type="text" autocomplete="off" v-model="formData.dictItemDto[scope.$index].refDictItemValue" clearable readonly="true">
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="doShowItemDictDialog(scope.$index)"></i>
                    </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sortOrder" label="排序" width="100">
                <template slot-scope="scope">
                  <el-input v-model="formData.dictItemDto[scope.$index].sortOrder" placeholder="请输入">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="remarks" label="备注信息" width="180">
                <template slot-scope="scope">
                  <el-input v-model="formData.dictItemDto[scope.$index].remarks" placeholder="请输入">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="sys_dict_del">
                <template slot-scope="scope">
                  <div @click="handleDelete(scope.$index)">
                    <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-form>
    <dictView v-if="showDictDialog" :visiable.sync="showDictDialog" multi="true" :param="dictParam" style="position: absolute !important;bottom: 30px!important;" class="pager_fixed"
                        @dictConfirm="dictConfirm" />
    <dictItemView v-if="showDictItemDialog" :visiable.sync="showDictItemDialog" multi="true" :param="dictItemParam" style="position: absolute !important;bottom: 30px!important;" class="pager_fixed"
                        @dictItemConfirm="dictItemConfirm" />
  </div>
</template>
<script>
import api from "@/api/projectApi";
import dictView from './dictDialog.vue';
import dictItemView from './dictItemDialog.vue';
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";
export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {dictView,dictItemView},
  data() {
    return {
      sys_dict_edit: false,
      sys_dict_add: false,
      sys_dict_del: false,

      showDictDialog:false,
      showDictItemDialog:false,
      dictParam:{},
      dictItemParam:{},
      dictTypes:[],
      formData: {
        id: null,
        dictItemDto:[]
      },

      activeName: 'first',
      isEdit: false,
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.sys_dict_edit = this.permissions['sys_dict_edit']
    this.sys_dict_add = this.permissions['sys_dict_add']
    this.sys_dict_del = this.permissions['sys_dict_del']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.formData,"formData的值");
  },
  mounted() {
    this.getData();
    this.getDictTypes()
  },
  methods: {
    lin(row){
console.log(row,"111111111111");
    },
    doShowDictDialog(index){
      this.dictParam.index = index;
      this.showDictDialog = true;
    },
    dictConfirm(row,index){
      this.$set(this.formData.dictItemDto[index],"refDictName",row.description);
      this.$set(this.formData.dictItemDto[index],"refDictId",row.id);
    },
    doShowItemDictDialog(index){
      this.dictItemParam.index = index;
      this.dictItemParam.dictId =  this.formData.dictItemDto[index].refDictId;
      this.showDictItemDialog = true;
    },
    dictItemConfirm(row,index){
      this.$set(this.formData.dictItemDto[index],"refDictName",row.dictDescription);
      this.$set(this.formData.dictItemDto[index],"refDictId",row.dictId);
      this.$set(this.formData.dictItemDto[index],"refDictItemValue",row.label);
      this.$set(this.formData.dictItemDto[index],"refDictItemId",row.id);
    },
    getDictTypes(){
      this.$http({
        url: "/admin/dict/type/dict_type",
        method: 'get',
      }).then(res => {
        this.dictTypes = res.data.data;
      })
    },
    AddListRow() {
      this.formData.dictItemDto.push({})
    },
    handleDelete(index){
       this.formData.dictItemDto.splice(index, 1);
    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.dict.getDataUrl,
          method: 'post',
          data: {
            id: this._dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data;
        })
      }
    },

    saveData() {
      if(!this.formData.dictType){
        this.$message({message: '类型必填', type: 'warning'});
        return;
      }
      if(!this.formData.description){
        this.$message({message: '编码必填', type: 'warning'});
        return;
      }
      if(!this.formData.systemFlag){
        this.$message({message: '字典类型必填', type: 'warning'});
        return;
      }
      this.$baseConfirm('您确定要保存吗？').then(() => {
        var url = this.isEdit ? api.dict.updateDataUrl : api.dict.addDataUrl
        this.$http({
          url: url,
          method: `post`,
          data: this.formData,
          isLoading: true,
        }).then(() => {
          this.$message.success("保存成功！");
          this.goBackIndex()
        })

      });
    }
  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.table-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.table-cell {
  flex: 1;
  margin-right: 10px;
}
.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

</style>
